// extracted by mini-css-extract-plugin
export default {"card":"Reason_card__-XJ8X","iconEven":"Reason_iconEven__mwdwz","iconOdd":"Reason_iconOdd__1ib6d"};